// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Documentation = function Documentation(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.19 2.07h-4.13C8.62 2.07 8 3.14 8 3.21s-.62-1.14-3.06-1.14H.82a.31.31 0 00-.31.31v9.92a.31.31 0 00.31.31h3.05A6.8 6.8 0 018 13.92a6.8 6.8 0 014.12-1.31h3.06a.3.3 0 00.3-.31V2.38a.3.3 0 00-.29-.31zm-.73 9.33a.12.12 0 01-.12.12H11.6a5.39 5.39 0 00-3.21.94V4.32a2.65 2.65 0 012.38-1.11h3.57a.12.12 0 01.12.11z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.71 4.47c-1.65 0-2.28.27-2.63.58a.2.2 0 00-.08.14v1c.39-.3.84-.62 2.61-.62h2.09v-1.1zM9.08 7.38a.2.2 0 00-.08.14v1.06c.39-.31.84-.63 2.61-.63h2.09V6.81h-2c-1.64 0-2.27.27-2.62.57zM9.08 9.72a.2.2 0 00-.08.14v1.06c.39-.31.84-.63 2.61-.63h2.09V9.15h-2c-1.64 0-2.27.27-2.62.57z"
    }))
  );
};

export default Documentation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Documentation.js
// module id = 997
// module chunks = 0